const udhrPreamble = `
הואיל והכרה בכבוד הטבעי לכל בני משפחת האדם ובזכויותיהם השוות והבלתי נפקעות הוא יסוד החופש, הצדק והשלום בעולם

הואיל והזלזול בזכויות האדם וביזוין הבשילו מעשים פראיים שפגעו קשה במצפונה של האנושות, בניין עולם שבו ייהנו כל יצורי אנוש מחירות הדיבור והאמונה ומן החירות מפחד וממחסור, הוכרז כראש שאיפותיו של כל אדם

הואיל והכרח חיוני הוא שזכויות האדם תהיינה מוגנות בכוח שלטונו של החוק, שלא יהא האדם אנוס, כמפלט אחרון, להשליך את יהבו על מרידה בעריצות ובדיכוי

הואיל והכרח חיוני הוא לקדם את התפתחותם של יחסי ידידות בין האומות

הואיל והעמים המאוגדים בארגון האומות המאוחדות חזרו ואישרו במגילה את אמונתם בזכויות היסוד של האדם, בכבודה ובערכה של אישיותו ובזכות שווה לגבר ולאישה ומנוי וגמור אתם לסייע לקידמה חברתית ולהעלאת רמת החיים מתוך יתר חירות

הואיל והמדינות החברות התחייבו לפעול, בשיתוף עם ארגון האומות המאוחדות, לטיפוח יחס כבוד כללי אל זכויות האדם ואל חירויות היסוד והקפדה על קיומן

הואיל והבנה משותפת במהותן של זכויות וחירויות אלה היא תנאי חשוב לקיומה השלם של התחייבות זו

לפיכך מכריזה העצרת באוזני כל באי העולם את ההכרזה הזאת בדבר זכויות האדם כרמת הישגים כללית לכל העמים והאומות. כדי שכל יחיד וכל גוף חברתי ישווה תמיד לנגד עיניו וישאף לטפח, דרך לימוד וחינוך, יחס של כבוד אל הזכויות ואל החירויות הללו, ולהבטיח באמצעים הדרגתיים, לאומיים ובינלאומיים, שההכרה בעקרונות אלה וההקפדה עליהם תהא כללית ויעילה בקרב אוכלוסי המדינות החברות ובקרב האוכלוסים שבארצות שיפוטם.
`;

const udhr1 = `
כל בני אדם נולדו בני חורין ושווים בערכם ובזכויותיהם. כולם חוננו בתבונה ובמצפון, לפיכך חובה עליהם לנהוג איש ברעהו ברוח של אחווה.
`;

module.exports = {
    name: 'Hebrew',
    udhrPreamble,
    udhr1,
    direction: 'rtl',
    lang: 'he',
}